import palette from 'lib/styles/palette';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import useDashboardCount from 'hooks/common/useDashboardCount';
import { SIDEBAR_MENU } from 'lib/constant/sidebar';
import { VERSION } from 'lib/constant/index';
import { useSelector } from 'react-redux';
import { BsPeopleFill } from 'react-icons/bs';

const SidebarSubMenu = ({ subMenu }) => {
  const navigate = useNavigate();
  const { dashboardCounts } = useDashboardCount();

  return (
    <SidebarSubMenuBlock onClick={() => navigate(subMenu.path)}>
      {subMenu.text}
      {subMenu.id === '2' && (
        <div className="count">{dashboardCounts?.storeCount}</div>
      )}
      {subMenu.id === '3' && (
        <div className="count">{dashboardCounts?.deviceCount}</div>
      )}
    </SidebarSubMenuBlock>
  );
};

const SidebarSubMenuBlock = styled.div`
  padding: 8px 30px 8px 45px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;

  &:hover {
    background: ${palette.theme[1]};
    color: ${palette.theme[3]};
  }

  .count {
    background: ${palette.gray[3]};
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 100%;
  }
`;

const SidebarMenu = ({ menu }) => {
  const navigate = useNavigate();
  const [showList, setShowList] = useState(false);

  const { partner } = useSelector(({ auth }) => auth);

  return (
    <>
      <SidebarMenuBlock
        onClick={() => {
          if (menu.subMenu) {
            setShowList(prev => !prev);
          } else {
            navigate(menu.path);
          }
        }}
      >
        <div className="icon">{menu.icon}</div>
        <div>{menu.text}</div>
        {menu.subMenu && <div className="downIcon">{menu.downIcon}</div>}
      </SidebarMenuBlock>
      {showList &&
        menu.subMenu
          .filter(subMenu =>
            partner === 'seedn' ? subMenu : subMenu.id !== '1',
          )
          .map(subMenu => (
            <SidebarSubMenu key={subMenu.id} subMenu={subMenu} />
          ))}
    </>
  );
};

const SidebarMenuBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0px 15px 15px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${palette.theme[1]};
    color: ${palette.theme[3]};
  }

  .icon {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-right: 10px;
  }

  .count {
    background: ${palette.gray[3]};
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 100%;
    margin-left: 10px;
  }

  .downIcon {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-left: 15px;
    color: rgba(0, 0, 0, 0.2);
  }
`;

const SidebarTemplate = ({ children }) => {
  const { pathname } = useLocation();
  const ref = useRef(null);
  const { userLevel, userType, partner } = useSelector(({ auth }) => auth);

  useEffect(() => {
    const backgroundElement = ref.current;
    backgroundElement.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SidebarTemplateBlock>
      <Sidebar>
        {SIDEBAR_MENU.filter(menu =>
          partner === 'seedn' ? menu : menu.id === '2',
        ).map(menu => (
          <SidebarMenu key={menu.id} menu={menu} />
        ))}
        {userLevel === '0' && userType === '1' && partner === 'seedn' && (
          <SidebarMenu
            menu={{
              id: '4',
              text: '계정정보 관리',
              icon: <BsPeopleFill />,
              path: '/admin/accounts',
            }}
          />
        )}
        <div className="version">버전 {VERSION}</div>
      </Sidebar>
      <Background id="background" ref={ref}>
        {children}
      </Background>
    </SidebarTemplateBlock>
  );
};

export default SidebarTemplate;

const SidebarTemplateBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;

const Sidebar = styled.div`
  padding-top: 15px;
  min-width: 230px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  font-weight: 500;

  .version {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: rgba(0, 0, 0, 0.4);
  }
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: ${palette.gray[0]};
  overflow-y: auto;
`;
